import React from 'react';


const RadioBoxDevice = (props) => {
  
	return( <div className="form-group">
    

    <div className="col-md-2 control-label">       
      <label htmlFor={props.name} className="form-label">{props.title}</label>
    </div>
    <div className="col-md-9">
    <div className="input-group">
    <div className="checkbox setting-radio">
      {props.options.map(option => {
       
        return (
          <label key={option} className="checkbox-inline">
            <input
              id = {props.name}
              name={props.name}
              onChange={props.handleChange}
              value={option}
              checked={ props.selectedOptions.indexOf(option) > -1 }
              type="radio" /> {option}
          </label>
        );
      })}
    </div>
    </div>
    </div>
    </div>
 
);

}

export default RadioBoxDevice;